/**
 * Single Odoo host for OpenEduCat APIs.
 *
 * Local (npm start):
 *   Browser calls /api/... on localhost → setupProxy forwards to
 *   `_odooBaseUrlProduction` from config.json.
 *
 * Deployed build:
 *   Browser calls `_odooBaseUrlProduction` directly.
 *
 * Examples for _odooBaseUrlProduction:
 *   Local Odoo:  http://localhost:8069
 *   Staging:     https://shaag-staging-35436066.dev.odoo.com
 *   Prod:        https://shaag.odoo.com
 *
 * Do NOT add /odoo — that is the browser UI only.
 */
const config = require('./config.json');

function normalizeOdooBaseUrl(raw) {
  let u = String(raw || 'http://localhost:8069').trim();
  u = u.replace(/\/+$/, '');
  u = u.replace(/\/odoo$/i, '');
  return u;
}

/** Used by setupProxy for localhost → Odoo forwarding */
const ODOO_PROXY_TARGET = normalizeOdooBaseUrl(
  config._odooBaseUrlProduction
);

/** Used by production / non-localhost browser builds */
const ODOO_BASE_URL = normalizeOdooBaseUrl(
  config._odooBaseUrlProduction
);

module.exports = {
  ODOO_BASE_URL,
  ODOO_PROXY_TARGET,
  normalizeOdooBaseUrl,
};
